// Public origin of the rental app, for links that staff send to customers
// from the browser (SMS/email built client-side). Never derive these from
// window.location.origin: staff may still have the app open on the legacy
// bbrentals.web.app host, and carriers filter texts carrying *.web.app links
// (Twilio error 30007). Mirrors functions/appConfig.js.
export const RENTAL_APP_BASE_URL = "https://book.bonitabikes.com";
